import { render, staticRenderFns } from "./SelectCourseCluster.vue?vue&type=template&id=31ff5a2c"
import script from "./SelectCourseCluster.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectCourseCluster.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ff5a2c')) {
      api.createRecord('31ff5a2c', component.options)
    } else {
      api.reload('31ff5a2c', component.options)
    }
    module.hot.accept("./SelectCourseCluster.vue?vue&type=template&id=31ff5a2c", function () {
      api.rerender('31ff5a2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/course/cluster/components/SelectCourseCluster.vue"
export default component.exports